import { SelectBox } from 'components'

export const SALES_MEASURE_DROPDOWN_OPTIONS = [
  { value: 'value', text: 'Value' },
  { value: 'volume', text: 'Volume' },
]

type SelectSalesMeasureProps = {
  salesMeasureState: {
    salesMeasure: string
    salesChannels?: string[]
  }
  onChange(salesMeasure: string): void
}

export const SelectSalesMeasure = (props: SelectSalesMeasureProps) => {
  const { salesMeasureState, onChange } = props
  const { salesMeasure, salesChannels } = salesMeasureState

  return (
    <div className="w-full sm:w-64" data-testid="select-sales-measure">
      <SelectBox
        id="sales-measure"
        label="Sales Measure"
        placeholder="Select sales measure"
        disabled={salesChannels?.includes('wholesale')}
        value={salesMeasure}
        onChange={onChange}
        options={SALES_MEASURE_DROPDOWN_OPTIONS}
      />
    </div>
  )
}
